import React from "react";
import AvatarDisplay from "components/avatar/display";
import { formatName } from "utils/index";
import { assetUrl } from "utils/index";
import { formatDateTimeForDisplay } from "utils/utils";
import CommentRenderer from "@/components/comment-renderer";
import MediaGallery from "components-v2/image-gallery";


export default function ActivityItem({ activity }) {
  if (!activity) return null;
  const user = activity.user_created;
  const att = activity.attachment;

  const galleryItems = React.useMemo(() => {
    if (!att) return [];
    const type = typeof att === "object" ? att.type : "";
    const id = typeof att === "object" ? att.id : att;
    const isVideo = type?.startsWith("video");
    const isImage = type?.startsWith("image");
    if (!isVideo && !isImage) return [];

    return [
      {
        url: assetUrl(id),
        type: type || (isVideo ? "video/*" : "image/*"),
        filename: typeof att === "object" ? (att.filename_download || att.title || id) : id,
      },
    ];
  }, [att]);

  return (
    <div className="flex gap-4">
      <AvatarDisplay className="w-8 h-8" user={user} />
      <div className="flex-1">
        <div className="flex items-center gap-2 mb-1">
          <span className="font-semibold text-sm">{formatName(user)}</span>
          <span className="text-xs text-gray-500">
            {formatDateTimeForDisplay(activity?.date_created)}
          </span>
        </div>
        <div className="flex flex-col gap-2 text-sm text-gray-700 bg-gray-100 p-3 rounded-lg max-w-[100%] break-words leading-relaxed">
          {galleryItems.length > 0 ? (
            <MediaGallery items={galleryItems} />
          ) : null}

          {activity?.comment ? (
            <div className="text-gray-700 whitespace-pre-wrap break-words">
              <CommentRenderer comment={activity.comment} />
            </div>
          ) : null}
        </div>
      </div>
    </div>
  );
}

